export default "__VITE_ASSET__$Iv_S6AA__"